import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchWorksheets } from '../../api/worksheets';
import styles from './WorksheetListPage.module.css';

function WorksheetListPage() {
  const [worksheets, setWorksheets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [typeFilter, setTypeFilter] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    loadWorksheets();
  }, [typeFilter]);

  const loadWorksheets = async () => {
    setLoading(true);
    setError('');
    try {
      const result = await fetchWorksheets(typeFilter ? { type: typeFilter } : {});
      setWorksheets(result.data || result.worksheets || []);
    } catch (err) {
      setError('Failed to load worksheets');
    } finally {
      setLoading(false);
    }
  };

  const getTypeLabel = (type) => {
    switch (type) {
      case 'quiz': return 'Quiz';
      case 'homework': return 'Homework';
      case 'test': return 'Test';
      case 'worksheet': return 'Worksheet';
      default: return type;
    }
  };

  if (loading) return <div className={styles.loading}>Loading...</div>;

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1 className={styles.title}>Worksheets</h1>
        <button
          className={styles.newButton}
          onClick={() => navigate('/worksheets/new')}
        >
          + New Worksheet
        </button>
      </div>

      <div className={styles.filterBar}>
        <select
          className={styles.filterSelect}
          value={typeFilter}
          onChange={(e) => setTypeFilter(e.target.value)}
          aria-label="Filter by type"
        >
          <option value="">All Types</option>
          <option value="quiz">Quizzes</option>
          <option value="homework">Homework</option>
          <option value="test">Tests</option>
          <option value="worksheet">Worksheets</option>
        </select>
      </div>

      {error && <div className={styles.error}>{error}</div>}

      {worksheets.length === 0 ? (
        <div className={styles.emptyState}>
          <p>No worksheets yet.</p>
          <p>Create your first worksheet to get started!</p>
        </div>
      ) : (
        <div className={styles.list}>
          {worksheets.map(ws => (
            <div
              key={ws.id}
              className={styles.card}
              onClick={() => navigate(`/worksheets/${ws.id}/edit`)}
            >
              <div className={styles.cardHeader}>
                <h3 className={styles.cardTitle}>{ws.title}</h3>
                <span className={styles.typeBadge}>{getTypeLabel(ws.type)}</span>
              </div>
              <div className={styles.cardMeta}>
                <span>{ws.subject}</span>
                <span>Grade {ws.gradeLevel}</span>
                <span>{ws._count?.questions || 0} questions</span>
                {ws.scheduledDate && (
                  <span>{new Date(ws.scheduledDate).toLocaleDateString()}</span>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default WorksheetListPage;
